import { LoadingDots } from "@mesketch/svg";
import { lazy } from "react";
import { FormattedMessage } from "react-intl";

// Obrazovky mezi koly a Skica se načítají zvlášť od obrazovky položky (NFR-003 rozpočet
// velikosti, dělení kódu podle tras).

export const RoundResult = lazy(() => import("./RoundResult.js").then((m) => ({ default: m.RoundResult })));
export const Sketch = lazy(() => import("./Sketch.js").then((m) => ({ default: m.Sketch })));
/** Obraz osoby v Moje já (CR-027 §5): kód obrazu jen na stránkách, které ho ukazují. */
export const OwnerComposite = lazy(() => import("./Composite.js").then((m) => ({ default: m.OwnerComposite })));

/** Čekání na kód obrazovky: animace „Skica se kreslí…“ (DES-003 §4). */
export function Drawing() {
  return (
    <div className="loader" role="status" data-testid="completing">
      <LoadingDots />
      <span>
        <FormattedMessage id="test.completing" />
      </span>
    </div>
  );
}
